import { API_URL, CONSULTANT_API_URL } from '../constants/config'
import { query } from './utilities'
import { request } from 'services/consultant/config'
import { checkConsultant } from '../helpers'

export const FetchSettlementService = (
  opportunityId: string,
  headers: any,
  httpVerb: any
) => {
  if (checkConsultant()) {
    return request(
      `${CONSULTANT_API_URL}/Opportunity/${opportunityId}/settlement`,
      headers,
      httpVerb
    )
  } else {
    return query(`${API_URL}/Opportunity/${opportunityId}/settlement`)
  }
}
